function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m12.45 32.17c14.94 0 23.11-12.38 23.11-23.11 0-.35 0-.7 0-1.05a16.54 16.54 0 0 0 4.03-4.21 16.06 16.06 0 0 1 -4.66 1.28 8.17 8.17 0 0 0 3.57-4.49 16.27 16.27 0 0 1 -5.16 2 8.13 8.13 0 0 0 -13.84 7.41 23 23 0 0 1 -16.74-8.52 8.13 8.13 0 0 0 2.51 10.85 8.11 8.11 0 0 1 -3.69-1v.1a8.12 8.12 0 0 0 6.52 8 8 8 0 0 1 -3.67.14 8.16 8.16 0 0 0 7.57 5.59 16.31 16.31 0 0 1 -10.07 3.48 15.63 15.63 0 0 1 -1.93-.12 23 23 0 0 0 12.45 3.65",
  fill: "#000"
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 39.59 32.17",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.780e88b5.svg";
export { ForwardRef as ReactComponent };